export default __webpack_public_path__ + "static/media/deleteIcon.f7d752eb.svg";